
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AnalyzerTitleCard',

  props: {
    icon: {
      type: String,
      default: 'globe'
    },
    analyzerLogo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleClick(event: Event): void {
      this.$emit('click', event)
    }
  }
})
